"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = void 0;
exports.version = "3.0.2";
//# sourceMappingURL=version.js.map